<section class="py-3">
  <div class="container-fluid card">
    <h3 class="text strat pt-3">
      Service List
      <div class="actions-itmes">
        <span class="text-filters">
          <select class="form-select m-1 default-form-group-border" #payMode (change)="creditFilterList(payMode.value)">
            <option value="" [selected]="'By Payment Mode'" disabled>
              Filter: Payment Mode
            </option>
            <option value="Cash">Cash</option>
            <option value="BankTransfer">Bank Transfer</option>
            <option value="UPI">UPI</option>
            <option value="Card">Card</option>
            <option value="Credit">Credit</option>
            <option value="">Show All</option>
          </select> </span>&nbsp;<button class="btn app-btn-primary text-end m-1" [routerLink]="'/service-entry'">
          Add Service
        </button>
      </div>
    </h3>
    <div class="row pt-3">
      <div class="table-responsive" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="300" (scrolled)="loadMore()">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Date/Time</th>
              <th scope="col" sortable="tyre_size">Branch</th>
              <th scope="col">Discount</th>
              <th scope="col">Amount</th>
              <th scope="col" style="width: 10px;">Payment</th>
              <th scope="col">Invoice</th>
            </tr>
          </thead>
          <tbody>
            @for (name of stockServiceData; track name) {
            <tr>
              <td>{{ name?.created | date: "dd-MM-yyyy hh:mm a" : "Asia/Kolkata" }}</td>
              <td>{{ name.company?.name }}</td>
              <td>{{ name.serviceId.discount || "-" }}</td>
              <td>{{ name.serviceId.totalAmount }}</td>
              @if (name.serviceId.paymentType) {
              <td>
                {{ name.serviceId.paymentType }}
                @if (name.serviceId.paymentMode) {
                <span>/{{ name.serviceId.paymentMode }}</span>
                }
              </td>
              }
              @if (!name.serviceId.paymentType) {
              <td>&nbsp;</td>
              }
              <td>
                <a href="{{ name.invoice }}" target="_blank">
                  @if (name.invoice) {
                  <fa-icon [icon]="faEye" class="btn app-btn-primary btn-sm" ngbTooltip="View"
                    [placement]="'top'"></fa-icon>
                  }</a>&nbsp;{{ name?.invoiceNumber }}
              </td>
            </tr>
            }
          </tbody>
        </table>
        @if (loader) {
        <div>
          <div class="custom-col-width-100 d-flex justify-content-center">
            <app-loader [loadingIcon]="loader"></app-loader>
          </div>
        </div>
        }
        @if (!loader && stockServiceData.length === 0) {
        <div>
          <div class="custom-col-width-100 text-danger d-flex justify-content-center">
            No Records Found!
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</section>

@if (isToster) {
<app-toaster [title]="message" (closeToaster)="closeToster($event)"></app-toaster>
}